export const urlWithLegalEntity = (url: string, legalEntityUuid: string | null): string => {
  if (legalEntityUuid) return `${url}?legalEntityUuid=${legalEntityUuid}`;
  return url;
};
